import axios from "axios";
import { axiosConfig } from "../../config/index";
import {
  DOOR_ADDED,
  DOOR_FETCHED,
  DOOR_EDITED,
  DOOR_DELETED,
  SET_DOOR,
} from "../types";

/**
 * Adds a new door to a site.
 */
export const addDoor = (doorInfo: any) => (dispatch: any) => {
  const adddoorURL = `/api/doors/adddoor`;
  return new Promise((resolve, reject) => {
    axios
      .post(adddoorURL, doorInfo, axiosConfig)
      .then((res) => {
        dispatch({
          type: DOOR_ADDED,
          addedDoor: res.data,
        });
        dispatch(getAllDoors());
        resolve(res.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err?.response?.data || err);
      });
  });
};

/**
 * Fetches all available doors.
 */
export const getAllDoors = () => (dispatch: any) => {
  axios
    .get(`/api/doors/getalldoors`, axiosConfig)
    .then((res) => {
      dispatch({
        type: DOOR_FETCHED,
        doorData: res.data,
      });
    })
    .catch((err) => {
      console.error(err);
    });
};

/**
 * Edits details of an existing door.
 */
export const editDoor = (
  doorId: any,
  editedDoorData: any
) => (dispatch: any) => {
  return new Promise((resolve, reject) => {
    axios
      .put(
        `/api/doors/updatedoor/${doorId}`,
        editedDoorData,
        axiosConfig
      )
      .then((res) => {
        dispatch({
          type: DOOR_EDITED,
        });
        dispatch(getAllDoors());
        resolve(res.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err?.response?.data || err);
      });
  });
};

/**
 * Sets the active door in state.
 */
export const setDoor = (singleDoor: any) => {
  return {
    type: SET_DOOR,
    singleDoor,
  };
};

/**
 * Archives/deletes a door by ID.
 */
export const deleteDoor = (doorId: any) => (dispatch: any) => {
  return new Promise((resolve, reject) => {
    axios
      .put(
        `/api/doors/deletedoor/${doorId}`,
        {},
        axiosConfig
      )
      .then((res) => {
        dispatch({
          type: DOOR_DELETED,
        });
        dispatch(getAllDoors());
        resolve(res.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err?.response?.data || err);
      });
  });
};
